import { Pipe, PipeTransform } from '@angular/core';
import { OfferingPrice } from '@models/profileConfiguration/model';
import { Numbers } from '../utils/numbers';

@Pipe({ name: 'pricingTableProration' })
export class PricingTableProrationPipe implements PipeTransform {
  public transform(offeringPrice: OfferingPrice): string {
    let text = '';
    if (offeringPrice?.startMonthProrated) {
      text += `First month Prorated amount is ${Numbers.formatCurrency(offeringPrice.startMonthProrated)}. `;
    }
    if (offeringPrice?.endMonthProrated) {
      text += `End month Prorated amount is ${Numbers.formatCurrency(offeringPrice.endMonthProrated)}.`;
    }
    return text;
  }
}
